import { useEffect } from 'react';

const CANONICAL_BASE_URL = 'https://gradevit.technie.in';

function upsertMeta(name, content) {
  if (!content) return;
  let tag = document.querySelector(`meta[name="${name}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute('name', name);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', content);
}

function upsertCanonical(url) {
  let link = document.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement('link');
    link.setAttribute('rel', 'canonical');
    document.head.appendChild(link);
  }
  link.setAttribute('href', url);
}

export default function SEO({ title, description, keywords, canonicalPath }) {
  useEffect(() => {
    if (title) document.title = title;
    upsertMeta('description', description);
    upsertMeta('keywords', keywords);
    upsertCanonical(`${CANONICAL_BASE_URL}${canonicalPath || '/'}`);
  }, [title, description, keywords, canonicalPath]);

  return null;
}
